import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';

export default function BuilderNav({ step, maxStep, onBack, onNext, nextLabel, nextDisabled, submitting }) {
  const canBack = step > 0 && !submitting;

  return (
    <div data-testid="builder-nav" className="flex items-center justify-between gap-4 mt-8">
      {/* Ghost back link — deliberately minimal so the primary CTA owns attention */}
      <button
        type="button"
        data-testid="builder-back-btn"
        onClick={onBack}
        disabled={!canBack}
        aria-label="Previous step"
        className={`group inline-flex items-center gap-1.5 text-xs sm:text-sm font-medium tracking-wide transition-opacity
          ${canBack
            ? 'text-slate-500 dark:text-slate-500 hover:text-[#0A0A0A] dark:hover:text-white cursor-pointer'
            : 'opacity-0 pointer-events-none'}`}
      >
        <ArrowLeft className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-0.5" />
        Back
      </button>

      <button
        type="button"
        data-testid="builder-next-btn"
        onClick={onNext}
        disabled={nextDisabled || submitting}
        className="group inline-flex items-center gap-2 flex-1 sm:flex-none justify-center bg-[#00E5FF] text-[#0A0A0A] px-6 py-3 rounded-xl text-sm font-bold hover:bg-white hover:shadow-[0_0_24px_rgba(0,229,255,0.5)] dark:hover:bg-white transition-all disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none active:scale-[0.98]"
      >
        {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
        {nextLabel || (step < maxStep ? 'Continue' : 'Submit')}
        {!submitting && <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />}
      </button>
    </div>
  );
}
